import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '../../utils';
export function Hr(props) {
    return _jsx(HrStyled, { ...props });
}
const HrStyled = styled('hr', {
    shouldForwardProp: (prop) => prop !== 'marginTop' && prop !== 'marginBottom',
})(({ theme, marginBottom, marginTop }) => ({
    border: 'none',
    borderTop: `1px solid ${theme.palette.secondary.contrastText}`,
    width: '75%',
    marginTop: theme.spacing(marginTop ?? 1),
    marginBottom: theme.spacing(marginBottom ?? 1),
}));
